import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-mobile-verify',
  templateUrl: './mobile-verify.component.html',
  styleUrls: ['./mobile-verify.component.scss'],
})
export class MobileVerifyComponent implements OnInit {

  constructor() { }

  ngOnInit() {}

}
